(function(){
  // scroll reveals (subtle; skipped when the visitor prefers reduced motion)
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(document.body.classList.contains('reveals-on')){
    if(reduce||!('IntersectionObserver' in window)){document.querySelectorAll('.rv').forEach(function(el){el.classList.add('in');});}
    else{
      var io=new IntersectionObserver(function(es){es.forEach(function(e){
        if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}
      });},{threshold:.12});
      document.querySelectorAll('.rv').forEach(function(el){io.observe(el);});
    }
  }

  // ---- mobile menu: a dialog with focus moved in, Escape to close, focus returned to the toggle ----
  var mm=document.getElementById('MobileMenu'),lastToggle=null;
  function openMenu(btn){if(!mm)return;lastToggle=btn||null;mm.classList.add('open');mm.setAttribute('aria-hidden','false');document.body.classList.add('menu-open');
    document.querySelectorAll('[data-menu-open]').forEach(function(b){b.setAttribute('aria-expanded','true');});
    var first=mm.querySelector('.mm-list a');setTimeout(function(){(first||mm.querySelector('[data-menu-close]')).focus();},60);}
  function closeMenu(){if(!mm||!mm.classList.contains('open'))return;mm.classList.remove('open');mm.setAttribute('aria-hidden','true');document.body.classList.remove('menu-open');
    document.querySelectorAll('[data-menu-open]').forEach(function(b){b.setAttribute('aria-expanded','false');});if(lastToggle)lastToggle.focus();}
  document.querySelectorAll('[data-menu-open]').forEach(function(b){b.addEventListener('click',function(){openMenu(b);});});
  document.querySelectorAll('[data-menu-close]').forEach(function(b){b.addEventListener('click',closeMenu);});
  if(mm){
    mm.addEventListener('click',function(e){var a=e.target.closest('a');if(a&&a.getAttribute('href')&&a.getAttribute('href').indexOf('#')>-1)closeMenu();});
    mm.addEventListener('keydown',function(e){
      if(e.key!=='Tab')return;
      var f=[].slice.call(mm.querySelectorAll('a,button')).filter(function(x){return x.offsetParent!==null;});if(!f.length)return;
      if(e.shiftKey&&document.activeElement===f[0]){e.preventDefault();f[f.length-1].focus();}
      else if(!e.shiftKey&&document.activeElement===f[f.length-1]){e.preventDefault();f[0].focus();}
    });
  }

  // ---- cart drawer ----
  var drawer=document.getElementById('CartDrawer'),overlay=document.getElementById('CartOverlay'),cartOpener=null;
  function openCart(){if(!drawer)return;if(!drawer.classList.contains('open'))cartOpener=document.activeElement;drawer.classList.add('open');overlay.classList.add('open');drawer.setAttribute('aria-hidden','false');var c=drawer.querySelector('[data-cart-close]');if(c)c.focus();}
  // closing returns keyboard focus to whatever opened the drawer (the bag link, or an add-to-bag button)
  function closeCart(){if(!drawer||!drawer.classList.contains('open'))return;drawer.classList.remove('open');overlay.classList.remove('open');drawer.setAttribute('aria-hidden','true');
    if(drawer.contains(document.activeElement)||document.activeElement===document.body){if(cartOpener&&cartOpener.focus&&document.contains(cartOpener))cartOpener.focus();}cartOpener=null;}
  // while open, Tab stays inside the drawer
  drawer&&drawer.addEventListener('keydown',function(e){
    if(e.key!=='Tab')return;
    var f=[].slice.call(drawer.querySelectorAll('a[href],button,input,select,textarea')).filter(function(x){return x.offsetParent!==null&&!x.disabled;});if(!f.length)return;
    if(e.shiftKey&&document.activeElement===f[0]){e.preventDefault();f[f.length-1].focus();}
    else if(!e.shiftKey&&document.activeElement===f[f.length-1]){e.preventDefault();f[0].focus();}
  });
  document.querySelectorAll('[data-cart-open]').forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();refreshCart().then(openCart);});});
  document.querySelectorAll('[data-cart-close]').forEach(function(b){b.addEventListener('click',closeCart);});
  overlay&&overlay.addEventListener('click',closeCart);
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeCart();closeMenu();}});

  var money=function(c){return '$'+(c/100).toFixed(2);};
  var esc=function(v){return String(v==null?'':v).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});};
  var THRESH=drawer&&drawer.dataset.threshold?parseFloat(drawer.dataset.threshold)*100:0;

  function renderCart(cart){
    document.querySelectorAll('[data-cart-count]').forEach(function(el){el.textContent='('+cart.item_count+')';});
    if(!drawer)return;
    var items=document.getElementById('CdItems'),foot=document.getElementById('CdFoot'),
        empty=document.getElementById('CdEmpty'),meter=document.getElementById('CdMeter');
    if(cart.item_count===0){items.style.display='none';foot.style.display='none';if(meter)meter.style.display='none';empty.style.display='flex';return;}
    empty.style.display='none';items.style.display='block';foot.style.display='block';
    items.innerHTML=cart.items.map(function(it,i){
      return '<div class="cd-item">'
        +'<img src="'+(it.image?esc(it.image.replace(/(\.[a-z]+)(\?|$)/,'_180x$1$2')):'')+'" alt="" loading="lazy">'
        +'<div><h4>'+esc(it.product_title)+'</h4>'
        +(it.variant_title&&it.variant_title!=='Default Title'?'<div class="vr">'+esc(it.variant_title)+'</div>':'')
        +(it.properties?Object.keys(it.properties).filter(function(k){return k.charAt(0)!=='_'&&it.properties[k];}).map(function(k){return '<div class="vr">'+esc(k)+': '+esc(it.properties[k])+'</div>';}).join(''):'')
        +(it.selling_plan_allocation?'<div class="vr" style="color:var(--brass-text)">'+esc(it.selling_plan_allocation.selling_plan.name)+'</div>':'')
        +'<div class="qty"><button data-qty="'+(i+1)+':'+(it.quantity-1)+'" aria-label="Decrease quantity">−</button><span>'+it.quantity+'</span><button data-qty="'+(i+1)+':'+(it.quantity+1)+'" aria-label="Increase quantity">+</button></div>'
        +'<br><button class="rm" data-qty="'+(i+1)+':0">Remove</button></div>'
        +'<div class="price">'+money(it.final_line_price)+'</div></div>';
    }).join('');
    document.getElementById('CdSubtotal').textContent=money(cart.total_price);
    if(meter&&THRESH>0){
      meter.style.display='block';
      var pct=Math.min(100,cart.total_price/THRESH*100);
      meter.querySelector('.bar i').style.width=pct+'%';
      meter.querySelector('.txt').innerHTML=cart.total_price>=THRESH
        ?'<b>Complimentary shipping</b> — unlocked.'
        :'You’re <b>'+money(THRESH-cart.total_price)+'</b> from complimentary shipping.';
    }else if(meter){meter.style.display='none';}
    items.querySelectorAll('[data-qty]').forEach(function(b){
      b.addEventListener('click',function(){
        var p=b.dataset.qty.split(':');
        fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:+p[0],quantity:+p[1]})})
          .then(function(r){return r.json();}).then(renderCart);
      });
    });
  }
  function refreshCart(){return fetch('/cart.js').then(function(r){return r.json();}).then(function(c){renderCart(c);return c;});}
  window.LumeraRefreshCart=refreshCart;
  window.LumeraOpenCart=function(){return refreshCart().then(function(c){openCart();return c;});};

  // ---- product page: the price shown follows the chosen option ----
  document.querySelectorAll('select[data-variant-select]').forEach(function(sel){
    var out=document.getElementById(sel.dataset.priceTarget||'ProductPrice');
    function sync(){var o=sel.options[sel.selectedIndex];if(out&&o&&o.dataset.price)out.textContent=o.dataset.price;}
    sel.addEventListener('change',sync);sync();
  });

  // product form ajax add (shows Shopify's own message when an add is refused, e.g. a required option)
  document.querySelectorAll('form[data-ajax-cart]').forEach(function(f){
    f.addEventListener('submit',function(e){
      e.preventDefault();
      var btn=f.querySelector('[type="submit"]'),orig=btn.textContent,msg=f.querySelector('[data-form-msg]');
      btn.textContent='Adding…';btn.disabled=true;if(msg)msg.textContent='';
      fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(f)})
        .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j};});})
        .then(function(res){btn.textContent=orig;btn.disabled=false;
          if(!res.ok){if(msg)msg.textContent=res.j.description||res.j.message||'This item couldn’t be added.';return;}
          refreshCart().then(openCart);})
        .catch(function(){btn.textContent=orig;btn.disabled=false;if(msg)msg.textContent='This item couldn’t be added. Please try again.';});
    });
  });
  // quick add buttons (variant id)
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-quick-add]');if(!b)return;
    e.preventDefault();
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:+b.dataset.quickAdd,quantity:1})})
      .then(function(r){return r.json();}).then(function(){refreshCart().then(openCart);});
  });
  refreshCart();
})();
